/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonRet } from './PersonRet';
import {
    PersonRetFromJSON,
    PersonRetFromJSONTyped,
    PersonRetToJSON,
    PersonRetToJSONTyped,
} from './PersonRet';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetOrganizationsTeam200Response
 */
export interface GetOrganizationsTeam200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetOrganizationsTeam200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetOrganizationsTeam200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {Array<PersonRet>}
     * @memberof GetOrganizationsTeam200Response
     */
    result: Array<PersonRet>;
}

/**
 * Check if a given object implements the GetOrganizationsTeam200Response interface.
 */
export function instanceOfGetOrganizationsTeam200Response(value: object): value is GetOrganizationsTeam200Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function GetOrganizationsTeam200ResponseFromJSON(json: any): GetOrganizationsTeam200Response {
    return GetOrganizationsTeam200ResponseFromJSONTyped(json, false);
}

export function GetOrganizationsTeam200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationsTeam200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': ((json['result'] as Array<any>).map(PersonRetFromJSON)),
    };
}

export function GetOrganizationsTeam200ResponseToJSON(json: any): GetOrganizationsTeam200Response {
    return GetOrganizationsTeam200ResponseToJSONTyped(json, false);
}

export function GetOrganizationsTeam200ResponseToJSONTyped(value?: GetOrganizationsTeam200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': ((value['result'] as Array<any>).map(PersonRetToJSON)),
    };
}

